// extracted by mini-css-extract-plugin
export default {"products":"mB-z","card":"nB-z","oosMessaging":"oB-z"};